import React, { useState } from "react";
import classNames from "classnames";
import { Button } from "Components/ReactstrapSlim";
import { Dropdown as DropdownIcon } from "Components/Icons";

import classes from "./PricingCard.module.scss";

interface PricingMobileCardProps {
   title: string;
   subtitle?: string;
   description: string;
   actionText: string;
   link?: string;
   price?: string;
   icon?: React.ReactNode;
   action?: () => void;
}

const PricingMobileCard: React.FC<PricingMobileCardProps> = ({
   title,
   description,
   actionText,
   link,
   price,
   icon,
   children,
   action = () => undefined,
}) => {
   const [detailsOpen, setDetailsOpen] = useState(false);

   const detailsOpenToggle = () => {
      setDetailsOpen((s) => !s);
   };

   return (
      <div className={classes.mobileCard}>
         <div className={classes.mobileCardBody}>
            <a className={classes.cardTitle} href={link}>{title}</a>
            <span className={classes.mobileCardDescription}>{description}</span>
            <div className={classes.mobileCardContent}>
               <span className={classes.mobileCardContentText}>
                  {price}
               </span>
               <span
                  className={classes.mobileCardDetailsText}
                  onClick={detailsOpenToggle}
               >
                  Details
                  <DropdownIcon
                     className={classNames(
                        classes.mobileCardDetailsIcon,
                        detailsOpen && classes.mobileCardDetailsExpendedIcon
                     )}
                  />
               </span>
            </div>
            {detailsOpen && (
               <div className={classes.mobileCardDetails}>{children}</div>
            )}
         </div>
         <div className={classes.mobileCardActions}>
            <Button
               fluid
               color="primary"
               size="sm"
               className={classes.cardButton}
               onClick={action}
            >
               {actionText}
            </Button>
         </div>
      </div>
   );
};

export default PricingMobileCard;
